module.exports = __webpack_public_path__ + "static/img/paypal-checkout.d4ca4453.png";